export default "__VITE_ASSET__y4WT3wEF__"